import React from "react";
import { NextPage } from "next";
import Artists from "../../modules/Artists/Artists";
import { getPrefetchQueryWrapper } from "../../helpers/nextHelper";
import { dehydrate, QueryClient } from "react-query";
import { QueryKeys } from "../../common/queryKeys";
import { fetchArtistsPage } from "../../queries/artists.query";

const ArtistsPage: NextPage = () => {
  return <Artists />;
};

ArtistsPage.getInitialProps = getPrefetchQueryWrapper(async () => {
  const queryClient = new QueryClient();
  await queryClient.prefetchInfiniteQuery(QueryKeys.artists, fetchArtistsPage);

  return {
    dehydratedState: dehydrate(queryClient),
  };
});

export default ArtistsPage;
